<template>
    <div class="dispositivos-inventario">
        <h2>Inventario - Dispositivos Médicos</h2>
        <div class="inventario-content">
            <el-card>
                <div slot="header">
                    <span>Gestión de Inventario de Dispositivos Médicos</span>
                </div>
                <el-table :data="inventario" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="nombre" label="Nombre del Dispositivo"></el-table-column>
                    <el-table-column prop="categoria" label="Categoría"></el-table-column>
                    <el-table-column prop="cantidad" label="Cantidad"></el-table-column>
                    <el-table-column prop="estado" label="Estado"></el-table-column>
                    <el-table-column prop="ubicacion" label="Ubicación"></el-table-column>
                    <el-table-column label="Acciones" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="editarItem(scope.row)">Editar</el-button>
                            <el-button size="mini" type="danger" @click="eliminarItem(scope.row)">Eliminar</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosInventario',
    data() {
        return {
            inventario: [
                { id: 1, nombre: 'Monitor Cardíaco', categoria: 'Monitoreo', cantidad: 15, estado: 'Disponible', ubicacion: 'Almacén A' },
                { id: 2, nombre: 'Ventilador Mecánico', categoria: 'Respiración', cantidad: 8, estado: 'En Uso', ubicacion: 'Sala ICU' },
                { id: 3, nombre: 'Bomba de Infusión', categoria: 'Administración', cantidad: 25, estado: 'Disponible', ubicacion: 'Almacén B' },
                { id: 4, nombre: 'Desfibrilador', categoria: 'Emergencia', cantidad: 5, estado: 'Mantenimiento', ubicacion: 'Taller' }
            ]
        }
    },
    methods: {
        editarItem(item) {
            console.log('Editar item:', item)
        },
        eliminarItem(item) {
            console.log('Eliminar item:', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-inventario {
    padding: 20px;

    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }

    .inventario-content {
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);

            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;

                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }

            :deep(.el-table) {
                .el-table__header-wrapper {
                    .el-table__header {
                        th {
                            background-color: var(--color-surface-alt);
                            color: var(--color-primary);
                            font-weight: 500;
                        }
                    }
                }

                .el-table__body-wrapper {
                    .el-table__body {
                        td {
                            color: var(--color-surface-muted);
                        }
                    }
                }
            }

            :deep(.el-button--mini) {
                border-radius: var(--radius-sm);

                &.el-button--default {
                    border-color: var(--color-btn-primary);
                    color: var(--color-btn-primary);

                    &:hover {
                        background-color: var(--color-btn-primary);
                        color: #fff;
                    }
                }

                &.el-button--danger {
                    border-color: var(--color-btn-danger);
                    color: var(--color-btn-danger);

                    &:hover {
                        background-color: var(--color-btn-danger);
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>